import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { ViewQuestionComponent } from '../view-question/view-question.component';
import { UploadServiceService } from '../service/upload-service.service';

@Component({
    selector: 'app-list-questions',
    templateUrl: './list-questions.component.html',
    styleUrls: ['./list-questions.component.css'],
    standalone: false
})
export class ListQuestionsComponent implements OnInit {
  displayedColumns: string[] = ['questionTitle', 'grade', 'timeline','edit'];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(private dialog:MatDialog, private _uploadService:UploadServiceService) { }

  questionsArray=[]

   requests: MatTableDataSource<any>;

  ngOnInit(): void {
    this.requests = new MatTableDataSource(this.questionsArray);
    this.requests.paginator = this.paginator;
    this.requests.sort = this.sort;

    this._uploadService.getAllQuestion().subscribe((data)=>{
      console.log("DATA",data);
      this.questionsArray = data["resp"]
    })

  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.requests.filter = filterValue.trim().toLowerCase();

    if (this.requests.paginator) {
      this.requests.paginator.firstPage();
    }
  }

  openQuestionPreview(typeId: string, questionId: string){
    // this.manufacturerService.publishProductRequestKeys({
    //   manufacturerID: manufacturerID,
    //   communityID: communityID
    // });
    this._uploadService.publishQuestionId(JSON.stringify({typeId,questionId}))
    this.dialog.open(ViewQuestionComponent, { height: '600px', width: '800px', });
  }

}
